<script>
import { api } from "@/state/services";
import Layout from "@/router/layouts/main";
import Breadcrumb from "@/components/Breadcrumb";
import { required } from "vuelidate/lib/validators";

export default {
  locales: {
    pt: {
      'My Address': 'Meus Endereços',
      'New Address': 'Novo endereço',
    },
    es: {
      'My Address': 'Meus Endereços',
      'New Address': 'Nueva dirección',
    }
  },
  components: {
    Layout,
    Breadcrumb,
  },
  data() {
    return {
      alert: {
        register: { type: '', message: '' },
        edit: { type: '', message: '' },
      },
      address: {
        loading: false,
        errored: false,
        status: false,
        list: []
      },
      edit: {
        loading: false,
        id: '',
        zipcode: '',
        address: '',
        number: '',
        complement: '',
        district: '',
        city: '',
        state: '',
      },
      register: {
        loading: false,
        zipcode: '',
        address: '',
        number: '',
        complement: '',
        district: '',
        city: '',
        state: '',
      },
      modal: {
        edit: false,
        register: false,
      },
    };
  },
  validations: {
    register: {
      zipcode: { required },
      address: { required },
      number: { required },
      complement: { },
      district: { required },
      city: { required },
      state: { required },
    },
    edit: {
      zipcode: { required },
      address: { required },
      number: { required },
      complement: { },
      district: { required },
      city: { required },
      state: { required },
    }
  },

  methods: {
    getAddress() {
      this.address.loading = true

      api
        .get('store/address')
        .then(response => {
          if (response.data.status=='success') {
            this.address.status = true
            this.address.list = response.data.list
          } else {
            this.address.status = false
            this.address.list = []
          }

          this.address.loading = false
        })
        .catch(error => {
          this.address.errored = error
          this.address.loading = false
        })
    },
    showAddress(id) {
      if (this.address.list[id]) {
        this.modal.edit = true

        this.edit = this.address.list[id]
        this.edit.id = id
      }
    },
    registerAddress() {
      this.register.loading = true
      this.$v.register.$touch();

      if (!this.$v.register.$invalid) {
        api
          .post('store/address', {
            zipcode: this.register.zipcode,
            address: this.register.address,
            number: this.register.number,
            complement: this.register.complement,
            district: this.register.district,
            city: this.register.city,
            state: this.register.state,
          })
          .then(response => {
            if (response.data.status=='success') {
              this.register.zipcode = ''
              this.register.address = ''
              this.register.number = ''
              this.register.complement = ''
              this.register.district = ''
              this.register.city = ''
              this.register.state = ''
              this.$v.register.$reset()

              this.modal.register = false

              this.getAddress()
            } else {
              this.alert.register.type = 'alert-danger'
              this.alert.register.message = response.data.message
            }

            this.register.loading = false
          })
          .catch(error => {
            if (error) {
              this.register.loading = false
            }
          })
      } else {
        this.register.loading = false
      }
    },
    editAddress() {
      this.edit.loading = true
      this.$v.edit.$touch();

      if (!this.$v.edit.$invalid) {
        api
          .post('store/address/edit', {
            id: this.edit.id,
            zipcode: this.edit.zipcode,
            address: this.edit.address,
            number: this.edit.number,
            complement: this.edit.complement,
            district: this.edit.district,
            city: this.edit.city,
            state: this.edit.state,
          })
          .then(response => {
            if (response.data.status=='success') {
              this.edit.zipcode = ''
              this.edit.address = ''
              this.edit.number = ''
              this.edit.complement = ''
              this.edit.district = ''
              this.edit.city = ''
              this.edit.state = ''
              this.$v.edit.$reset()

              this.modal.edit = false

              this.getAddress()
            } else {
              this.alert.edit.type = 'alert-danger'
              this.alert.edit.message = response.data.message
            }

            this.edit.loading = false
          })
          .catch(error => {
            if (error) {
              this.edit.loading = false
            }
          })
      } else {
        this.edit.loading = false
      }
    },
    delAddress(id) {
      if (id) {
        api
          .post('store/address/delete', {
            id: id,
          })
          .then(response => {
            if (response.data.status=='success') {
              this.getAddress()
            }
          })
      }
    },
    searchCepRegister() {
      if (this.register.zipcode.length == 9) {
        api
          .get("https://cep.m2n.com.br/" + this.register.zipcode.replace(/\D/g, ""))
          .then(response => {
            if (response.data.city == '') {
                this.alert.register.type = 'alert-danger'
                this.alert.register.message = 'O CEP informado é inválido.'
            } else {
              this.alert.register.type = ''
              this.alert.register.message = ''

              if (response.data.address) {
                this.register.address = response.data.address
              }
              if (response.data.district) {
                this.register.district = response.data.district
              }
              this.register.city = response.data.city
              this.register.state = response.data.state
            }
          })
      }
    },
    searchCepEdit() {
      if (this.edit.zipcode.length == 9) {
        api
          .get("https://cep.m2n.com.br/" + this.edit.zipcode.replace(/\D/g, ""))
          .then(response => {
            if (response.data.city == '') {
                this.alert.edit.type = 'alert-danger'
                this.alert.edit.message = 'O CEP informado é inválido.'
            } else {
              this.alert.edit.type = ''
              this.alert.edit.message = ''

              if (response.data.address) {
                this.edit.address = response.data.address
              }
              if (response.data.district) {
                this.edit.district = response.data.district
              }
              this.edit.city = response.data.city
              this.edit.state = response.data.state
            }
          })
      }
    },
  },
  mounted() {
    this.getAddress()
  },
};
</script>

<template>
  <Layout>
    <Breadcrumb :items="[{ text: 'Minha Conta', to: '/account' }, { text: 'Endereços' }]" />
    <div class="row">
      <div class="col-xl-7">
        <div class="page-title-box d-md-flex justify-content-between">
          <div>
            <h3 class="mb-0">{{ t('My Address') }}</h3>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <p v-if="address.loading"></p>
            <p v-else-if="!address.status" class="alert alert-warning text-center">Você ainda não possui um endereço cadastrado.</p>
            <div v-else v-for="(adr,id) in address.list" :key="id">
              <div class="d-flex mb-2 align-items-center">
                <div class="flex-fill bg-soft-warning rounded p-3 mr-2">
                  {{ adr.address }},
                  {{ adr.number }},
                  <span v-if="adr.complement">{{ adr.complement }},</span>
                  {{ adr.city }}/{{ adr.state }},
                  {{ adr.zipcode }}
                </div>
                <div>
                  <button v-on:click="showAddress(id)" class="btn btn-link btn-sm text-dark px-0"><i class="bx bx-edit align-middle font-size-20"></i></button>
                </div>
                <div>
                  <button v-on:click="delAddress(id)" class="btn btn-link btn-sm text-dark px-0"><i class="bx bx-trash align-middle font-size-20"></i></button>
                </div>
              </div>
            </div>
            <button v-on:click="modal.register = true;" class="btn btn-link btn-block text-default text-decoration-none border p-5"><i class="bx bx-plus-circle font-size-24"></i><br> {{ t('New Address') }} </button>
          </div>
        </div>
      </div>
      <b-modal v-model="modal.edit" title="Endereço" centered hide-footer>
        <b-form @submit.prevent="editAddress">
          <div v-if="alert.edit.message" :class="'alert ' + alert.edit.type">{{ t(alert.edit.message) }}</div>
          <b-form-group id="edit.zipcode" label="CEP" label-for="edit.zipcode">
            <b-form-input v-on:blur="searchCepEdit()" id="edit.zipcode" v-model="edit.zipcode" type="text" :class="{ 'is-invalid': $v.edit.zipcode.$error }" autocomplete="off" v-mask="'#####-###'"></b-form-input>
            <div v-if="$v.edit.zipcode.$error" class="invalid-feedback">
              <span v-if="!$v.edit.zipcode.required">O CEP é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="edit.address" label="Endereço" label-for="edit.address">
            <b-form-input id="edit.address" v-model="edit.address" type="text" :class="{ 'is-invalid': $v.edit.address.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.edit.address.$error" class="invalid-feedback">
              <span v-if="!$v.edit.address.required">O endereço é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="edit.number" label="Número" label-for="edit.number">
            <b-form-input id="edit.number" v-model="edit.number" type="text" :class="{ 'is-invalid': $v.edit.number.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.edit.number.$error" class="invalid-feedback">
              <span v-if="!$v.edit.number.required">O número é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="edit.complement" label="Complemento" label-for="edit.complement">
            <b-form-input id="edit.complement" v-model="edit.complement" type="text" :class="{ 'is-invalid': $v.edit.complement.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.edit.complement.$error" class="invalid-feedback">
              <span v-if="!$v.edit.complement.required">O complemento é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="edit.district" label="Bairro" label-for="edit.district">
            <b-form-input id="edit.district" v-model="edit.district" type="text" :class="{ 'is-invalid': $v.edit.district.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.edit.district.$error" class="invalid-feedback">
              <span v-if="!$v.edit.district.required">O bairro é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="edit.city" label="Cidade" label-for="edit.city">
            <b-form-input id="edit.city" class="bg-soft-info" v-model="edit.city" type="text" :class="{ 'is-invalid': $v.edit.city.$error }" autocomplete="off" readonly="readonly"></b-form-input>
            <div v-if="$v.edit.city.$error" class="invalid-feedback">
              <span v-if="!$v.edit.city.required">A cidade é obrigatória.</span>
            </div>
          </b-form-group>
          <b-form-group id="edit.state" label="Estado" label-for="edit.state">
            <b-form-input id="edit.state" class="bg-soft-info" v-model="edit.state" type="text" :class="{ 'is-invalid': $v.edit.state.$error }" autocomplete="off" readonly="readonly" v-mask="'XX'"></b-form-input>
            <div v-if="$v.edit.state.$error" class="invalid-feedback">
              <span v-if="!$v.edit.state.required">O estado é obrigatório.</span>
            </div>
          </b-form-group>
          <b-button class="mb-0" :disabled="this.edit.loading" type="submit" variant="default">
            Editar
            <b-spinner v-if="edit.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </b-button>
        </b-form>
      </b-modal>
      <b-modal v-model="modal.register" title="Endereço" centered hide-footer>
        <b-form @submit.prevent="registerAddress">
          <div v-if="alert.register.message" :class="'alert ' + alert.register.type">{{ t(alert.register.message) }}</div>
          <b-form-group id="register.zipcode" label="CEP" label-for="register.zipcode">
            <b-form-input v-on:blur="searchCepRegister()" id="register.zipcode" v-model="register.zipcode" type="text" :class="{ 'is-invalid': $v.register.zipcode.$error }" autocomplete="off" v-mask="'#####-###'"></b-form-input>
            <div v-if="$v.register.zipcode.$error" class="invalid-feedback">
              <span v-if="!$v.register.zipcode.required">O CEP é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="register.address" label="Endereço" label-for="register.address">
            <b-form-input id="register.address" v-model="register.address" type="text" :class="{ 'is-invalid': $v.register.address.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.register.address.$error" class="invalid-feedback">
              <span v-if="!$v.register.address.required">O endereço é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="register.number" label="Número" label-for="register.number">
            <b-form-input id="register.number" v-model="register.number" type="text" :class="{ 'is-invalid': $v.register.number.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.register.number.$error" class="invalid-feedback">
              <span v-if="!$v.register.number.required">O número é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="register.complement" label="Complemento" label-for="register.complement">
            <b-form-input id="register.complement" v-model="register.complement" type="text" :class="{ 'is-invalid': $v.register.complement.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.register.complement.$error" class="invalid-feedback">
              <span v-if="!$v.register.complement.required">O complemento é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="register.district" label="Bairro" label-for="register.district">
            <b-form-input id="register.district" v-model="register.district" type="text" :class="{ 'is-invalid': $v.register.district.$error }" autocomplete="off"></b-form-input>
            <div v-if="$v.register.district.$error" class="invalid-feedback">
              <span v-if="!$v.register.district.required">O bairro é obrigatório.</span>
            </div>
          </b-form-group>
          <b-form-group id="register.city" label="Cidade" label-for="register.city">
            <b-form-input id="register.city" class="bg-soft-info" v-model="register.city" type="text" :class="{ 'is-invalid': $v.register.city.$error }" autocomplete="off" readonly="readonly"></b-form-input>
            <div v-if="$v.register.city.$error" class="invalid-feedback">
              <span v-if="!$v.register.city.required">A cidade é obrigatória.</span>
            </div>
          </b-form-group>
          <b-form-group id="register.state" label="Estado" label-for="register.state">
            <b-form-input id="register.state" class="bg-soft-info" v-model="register.state" type="text" :class="{ 'is-invalid': $v.register.state.$error }" autocomplete="off" readonly="readonly" v-mask="'XX'"></b-form-input>
            <div v-if="$v.register.state.$error" class="invalid-feedback">
              <span v-if="!$v.register.state.required">O estado é obrigatório.</span>
            </div>
          </b-form-group>
          <b-button class="mb-0" :disabled="this.register.loading" type="submit" variant="default">
            Cadastrar
            <b-spinner v-if="register.loading" small class="ml-2 align-middle" variant="white" role="status"></b-spinner>
          </b-button>
        </b-form>
      </b-modal>
    </div>
  </Layout>
</template>